import {Pressable, StyleSheet, Text} from 'react-native';
import {Color} from "@/lib/styles";
import {Href} from "expo-router";
import Icon, {IconKind} from "@/lib/components/Icon";
import {useState} from "react";
import useCrossTabNavigation from "@/lib/crosstab";
import Split from "@/lib/components/Split";

type Props = {
    title?: string,
    color?: string,
    iconColor?: string,
    icon?: IconKind,
    dashed?: boolean,
    href: Href,
}

export default function NavButton({title, icon, color, href, dashed, iconColor}: Props) {
    const [hover, setHover] = useState(false);
    const {navigate} = useCrossTabNavigation();

    const themed_color = color ? color : Color.PrimaryText;
    const icon_color = iconColor ? iconColor : Color.PrimaryText;
    const iconSize = 16;

    return (
        <Pressable
            onPress={() => navigate(href)}
            onHoverIn={() => setHover(true)}
            onHoverOut={() => setHover(false)}
            style={[
                styles.container,
                {
                    borderColor: themed_color,
                    outlineColor: themed_color,
                    outlineWidth: hover ? 1 : 0,
                },
                dashed ? {borderStyle: "dashed"} : {},
            ]}
        >
            <Split left={<>
                {icon && <Icon kind={icon} size={iconSize} color={icon_color}/>}
                {title && <Text style={[styles.buttonLabel, {color: themed_color}]}>{title}</Text>}
            </>} right={<>
                <Icon kind={"chevronRight"}/>
            </>}
            />
        </Pressable>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        paddingHorizontal: 12,
        gap: 6,
        height: 48,
        borderRadius: 8,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: Color.PrimaryText,
        backgroundColor: "transparent",
        outlineStyle: "solid",
    },
    buttonLabel: {
        color: Color.PrimaryText,
        fontSize: 16,
    },
});